import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { dormancyStatistics } from 'lib/api/report';
import { userOnLogin } from 'lib/api/user';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
let initParam = {
  sDate: moment().add(-1, 'month').format('YYYYMMDD'),
  eDate: moment().format('YYYYMMDD'),
};
const Dormancy = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  useEffect(() => {
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    CORP_NAME: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'CORP_NAME').label} (
            {getHeadObj(headsMap, 'ADVER_ID').label})
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const corpName = getHeadObj(headsMap, 'CORP_NAME');
        let resultComponent;

        if (rowObj['CORP_NAME'] === 'total') {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['CORP_NAME'],
                corpName.type,
                corpName.format
              )}
            </>
          );
        } else {
          const resultName =
            rowObj['CORP_NAME'] + ' (' + rowObj['ADVER_ID'] + ')';
          resultComponent = (
            <IconAreaWrap
              text={resultName}
              icon="login"
              toolTipTitle={t('광고주 로그인')}
              onClick={(e) => handleOnLogin(rowObj['ADVER_ID'])}
            />
          );
        }

        return resultComponent;
      },
    },
    ADVER_ID: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  /**
   * 로그인처리
   */
  const handleOnLogin = (ADVER_ID) => {
    userOnLogin(ADVER_ID, 'manage')
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          alert('로그인에 실패했습니다. 관리자에게 문의하세요.');
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          initData={initParam}
          noneDisplayFilter={true}
          noneExternalFilter={true}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={dormancyStatistics}
            params={{ ...params }}
            sort="asc"
            order="CORP_NAME"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal
          />
        </>
      )}
    </>
  );
};

export default Dormancy;
